import Image from 'next/image'
import { useEffect } from 'react'
import { useClientSideTranslation } from 'src/services/i18n'
import { getTranslatedMarbleColor } from 'src/services/i18n/utils/gameTranslations'
import { useGetCurrentLanguage } from 'src/store/game'
import type { Marble } from 'src/types/domain/Marble'

type Props = Readonly<{
  marble: Marble
}>

export function RaceBannerWinner({ marble }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  useEffect(() => {
    if (marble.image) {
      const img = new window.Image()
      img.src = marble.image
    }
  }, [marble.image])

  return (
    <div className="entry" key={marble.uuid}>
      <div className="marble-wrapper">
        <div className="marble_blur" />
        <div className="marble active" data-tooltip={`${marble.number} -> ${t('Winner')}`}>
          {marble.imageAlt ? (
            <Image
              alt={marble.imageAlt}
              className="marble-image"
              draggable="false"
              fill
              priority
              sizes="60px"
              src={marble.imageAlt}
            />
          ) : (
            <Image
              alt={`Marble ${marble.number}`}
              className="marble-background-image"
              draggable="false"
              fill
              priority
              sizes="60px"
              src={marble.image ?? ''}
            />
          )}
        </div>
      </div>
      <div className="marble_winner_label">
        <div className={`marble-name marble-${marble.color}`}>
          <span>{getTranslatedMarbleColor(marble.color, t)}</span>
        </div>
        <span className="marble-position">{t('Winner')}</span>
      </div>
    </div>
  )
}
